import React, {useImperativeHandle, useRef, useState} from 'react'
import WizModal from '../../../components/modal/WizModal'
import Text from '../../../components/text/Text'
import WizButton from '../../../components/button/WizButton'
import {IReport} from '../../../apis/report/getReport'
import ic_arrow from '../../../assets/images/ic_arrow_right.png'
import WizImage from '../../../components/image/WizImage'
import WizTag from '../../../components/tag/WizTag'
import {editReportState} from '../../../apis/report/editReportState'
import {QueryClient} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../../hooks/QueryKey'

interface IProps {
    className?: string
    currentPage?: number
}

const ChangedStateModal = ({className, currentPage}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const [data, setData] = useState<IReport>()

    const queryClient = new QueryClient()

    useImperativeHandle(ref, () => ({
        show: report => {
            setData(report)
            modalRef.current.show()
        },
    }))

    const onClickChanged = async () => {
        await editReportState(data?.id, !data?.Checked).then(() => {
            queryClient.invalidateQueries({queryKey: QueryCacheKeys.other.getReport(currentPage)})
            alert('Changed Complete Report')
            modalRef.current.close()
        })
    }

    return (
        <>
            <WizModal title={'Changed Resolved'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02 text-center'}>Changed State</Text>
                <div className={'flex items-center space-x-[20px] mt-[10px] justify-center'}>
                    {data?.Checked ? <WizTag state={true}>Resolved</WizTag> : <WizTag state={false}>UnResolved</WizTag>}
                    <WizImage src={ic_arrow} />
                    {data?.Checked ? <WizTag state={false}>UnResolved</WizTag> : <WizTag state={true}>Resolved</WizTag>}
                </div>

                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton
                        text={data?.Checked ? 'UnResolved' : 'Resolved'}
                        type={data?.Checked ? 'red' : 'primary'}
                        className={'flex-1'}
                        onClick={() => onClickChanged()}
                    />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(ChangedStateModal)
